import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getAllLayerTempStyles } from "../../ducks/layerTempStyle/selectors";

export const useTempStyleName = (layerName: string): string | undefined => {
  const layerTempStyles = useSelector(getAllLayerTempStyles);

  return useMemo(() => {
    if (layerTempStyles[layerName]) {
      return layerTempStyles[layerName].id;
    }

    return undefined;
  }, [layerName, layerTempStyles]);
};
